import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { ItineraryBoxResumeComponent } from './itinerary-box-resume/itinerary-box-resume.component';
import { ItineraryResumeComponent } from './itinerary-resume.component';
import { PassengersResumeComponent } from './passengers-resume/passengers-resume.component';
import { CardFlightModule } from '../card-flight/card-flight.module';
import { WaitTimeBannerModule } from '../wait-time-banner/wait-time-banner.module';

@NgModule({
  declarations: [ItineraryResumeComponent, PassengersResumeComponent, ItineraryBoxResumeComponent],
  imports: [CommonModule, FormsModule, SharedModule, CardFlightModule, WaitTimeBannerModule],
  exports: [ItineraryResumeComponent, PassengersResumeComponent, ItineraryBoxResumeComponent]
})
export class ItineraryResumeModule {}
